import React from 'react'
import PropTypes from 'prop-types'
import AttachmentIcon from 'assets/images/attachment.svg'
import I18n from 'translations/i18n'
import FileInput from 'components/global/form/FileInput'

const Attachment = ({ meta: { error, touched }, input, id, useBase64, testId }) => {
  const { file_file_name = null } = input.value
  const attachmentCount = input.value ? `${I18n.t('attachment')} (1)` : I18n.t('add_attachment')

  return (
    <div
      data-testid={testId}
      className="redux-attachment"
    >
      <div>
        <img
          src={AttachmentIcon}
          alt="Attachment"
        />
        {useBase64 ? <p>{attachmentCount}</p> : <p>{file_file_name || I18n.t('add_attachment')}</p>}
      </div>
      <FileInput
        testId={`${testId}-file-input`}
        onDone={(file) => {
          if (useBase64) {
            return input.onChange(file.file)
          }
          return input.onChange(file)
        }}
        id={id}
        type="file"
      />
      <span
        testId={`${testId}-error`}
        className="redux-attachment--error"
      >
        {touched && error && error}
      </span>
    </div>
  )
}

Attachment.defaultProps = {
  testId: 'redux-attachment',
}

Attachment.propTypes = {
  id: PropTypes.string,
  testId: PropTypes.string,
  useBase64: PropTypes.bool,
  input: PropTypes.shape(),
  meta: PropTypes.shape(),
}

export default Attachment
